/*
 * analytics
 * 浏览器端，通过 __sr.gif 上报统计点
 */
(function() {
    var isiOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    // var eventName = isiOS ? 'pagehide' : 'beforeunload';
    // 统计点，注释项是浏览器端无法获取的项目;
    var analytics = {
        method: 'get', // 请求方式
        uploadtag: '', // 上报位置
        jsid: '', // js 生成唯一用户 id
        guid: '', // SDK 中获取的用户 id
        xua: '', // SDK 中获取的设备信息
        opentime: '', // 页面打开时间戳
        closetime: '', // 页面关闭时间戳
        visttime: '', // 访问时长
        vistcount: '', // 访问次数
        firstvist: false, // 是否为首次访问用户
        uid: '' // 用户唯一标识
    };
    var alias = SR.data.alias;
    var deviceInfo = {};
    var userInfo = {};
    var analyticsCookies = Cookies.get(alias.analyticsCookies);
    var startTime = new Date();
    var endTime;
    var hasUploadOnUnload = false;
    var appid = location.search.replace('?', '');

    // 上传统计日志
    function uploadAnalytics(analyticsData, tag) {
        analyticsData.uploadtag = tag;

        if (tag === 'unload') {
            analytics.opentime = startTime.getTime();
            endTime = new Date();
            analyticsData.closetime = endTime.getTime();
            analyticsData.visttime = (analytics.closetime - analytics.opentime) / 1000;
            analyticsData.cleanCache = Math.floor(Math.random() * 1000000);
            // 避免重复上报
            hasUploadOnUnload = true;
        }

        var query = analyticsToQuery(analyticsData);
        var timestamp = new Date() - 0;
        var img = new Image();
        img.src = location.protocol + '//' + location.host + '/dist/images/__sr.gif?' + appid + '&' + query + '&tp=' + timestamp;
        SR.state.isDebug && console.log('analyticsQuery: ', query);
    }

    if (analyticsCookies) {
        // 已有访问记录，访问次数 +1
        analyticsCookies = JSON.parse(analyticsCookies);
        if (analyticsCookies.jsid) {
            analyticsCookies.vistcount = Number(analyticsCookies.vistcount) + 1;
            analytics.vistcount = analyticsCookies.vistcount;
            analytics.jsid = analyticsCookies.jsid;
            SR.data.jsid = analyticsCookies.jsid;
            saveAnalytics();
        } else {
            createNewVisitor();
        }
    } else {
        createNewVisitor();
    }

    deviceInfo.callback = function(code, param) {
        // 只有在大师兄 webview 才能获取
        var deviceParams = JSON.parse(param);
        analytics.guid = deviceParams.guid;
        analytics.xua = deviceParams.xua;
        upNativeComm.exec('UPUser.getUserInfo', userInfo);
    };
    userInfo.callback = function(code, param) {
        var userParams = JSON.parse(param);
        analytics.uid = userParams.uid;
        uploadAnalytics(analytics, 'load', 'load');
    };
    if (SR.state.isNative && !SR.state.isDebug) {
        upNativeComm.exec('smartRobot.srGetUserInfo', deviceInfo);
    } else {
        // H5 直接上报，Native 等待回调完成后上报
        uploadAnalytics(analytics, 'load', 'load');
    }

    window.addEventListener('pagehide', function(event) {
        !hasUploadOnUnload && uploadAnalytics(analytics, 'unload', 'pagehide');
    });

    window.addEventListener('beforeunload', function(event) {
        !hasUploadOnUnload && uploadAnalytics(analytics, 'unload', 'beforeunload');
    });

    window.addEventListener('unload', function(event) {
        !hasUploadOnUnload && uploadAnalytics(analytics, 'unload', 'unload');
    });

    // 生成 jsid
    function generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-6xxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = ((d + Math.random() * 16) % 16) | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x7) | 0x8).toString(16);
        });
        uuid = uuid.replace(/-/gi, '');
        return uuid;
    }

    // 生成新访客
    function createNewVisitor() {
        var jsid = generateUUID();
        SR.data.jsid = jsid;
        analyticsCookies = {
            jsid: jsid,
            vistcount: 1
        };
        analytics.jsid = jsid;
        analytics.firstvist = true;
        analytics.vistcount = 1;
        saveAnalytics();
    }

    // 存储访问信息
    function saveAnalytics() {
        Cookies.set(alias.analyticsCookies, JSON.stringify(analyticsCookies), { expires: 1024 });
    }

    // 对象序列化
    function analyticsToQuery(analytics) {
        if (!analytics) {
            return;
        }
        var query = '';
        for (var key in analytics) {
            var keyName = alias[key] || key;
            query += keyName + '=' + analytics[key] + '&';
        }
        query = query.slice(0, -1);
        return query;
    }
})();
